import type { BookingTripConflict, WorkshopBookingState } from '@chukua/common';
import { ApiError } from '../../../../../shared/shared.api';

export const BOOKING_CONFLICTS_TRIPS = 'booking_conflicts_trips';

export const BOOKING_STATE_LABELS: Record<WorkshopBookingState, string> = {
  live: 'Booked',
  cancelled: 'Cancelled',
  superseded: 'Moved',
};

const dateTime = new Intl.DateTimeFormat('en-KE', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false });

export function formatInstant(iso: string): string {
  return dateTime.format(new Date(iso));
}

/** "Tue 10 Nov, 08:00 to 16:00" on one day, both ends in full across days; an open end reads "until delivered". */
export function formatWindow(startsAt: string, endsAt: string | null): string {
  if (endsAt === null) return `${formatInstant(startsAt)}, until delivered`;
  const start = new Date(startsAt);
  const end = new Date(endsAt);
  const isSameDay = start.toDateString() === end.toDateString();
  if (!isSameDay) return `${formatInstant(startsAt)} to ${formatInstant(endsAt)}`;
  return `${formatInstant(startsAt)} to ${end.toLocaleTimeString('en-KE', { hour: '2-digit', minute: '2-digit', hour12: false })}`;
}

/** The trips a refused booking ran into, when the server answered 409 `booking_conflicts_trips`; null for any other failure. */
export function conflictingTripsFrom(err: unknown): BookingTripConflict[] | null {
  if (!(err instanceof ApiError) || err.status !== 409) return null;
  const { code, trips } = (err.body ?? {}) as { code?: unknown; trips?: unknown };
  return code === BOOKING_CONFLICTS_TRIPS && Array.isArray(trips) ? (trips as BookingTripConflict[]) : null;
}

export function describeConflict(conflict: BookingTripConflict): string {
  return `${conflict.tripNumber}: ${formatWindow(conflict.startsAt, conflict.endsAt)}`;
}
